@use "Styles/includes/variables";
@use "Styles/mixins/functions";
@use "Styles/components/buttons";
@use "Static/icons/icomoon/style.scss";

:host {
    .comments {
        &__list {
            display: flex;
            flex-direction: column;
            gap: 16px;
            padding: 0;
            margin: 16px 0;
            list-style-type: none;
        }
    }
}
